export default __webpack_public_path__ + "static/media/art-slt-2.83e25ccf.png";